import React from 'react';
import { motion } from 'framer-motion';
import { BadgeDivider } from './Badge';
const CARTOON_IMG = 'https://cdn.magicpatterns.com/uploads/diPVFCDx1vN2kdSb3sEjTg/VU_BandCartoon_Group.png';
type Member = {
  name: string;
  role: string;
  bio: string;
};
const MEMBERS: Member[] = [{
  name: 'Nick Sette',
  role: 'Rhythm Guitar · Lead Vocals',
  bio: 'Cut his teeth in Jersey Shore clubs and New York City before bringing his Beatles-, Stones-, and Neil Young-inspired sound to Florida.'
}, {
  name: 'Frank Wells',
  role: 'Lead Guitar',
  bio: 'Went from teenage club gigs in New Jersey to touring the U.S. with The Box Tops, sharing stages with icons like Chubby Checker, The Grass Roots, and Dion and the Belmonts.'
}, {
  name: 'John Campbell',
  role: 'Keys · Backup Vocals · Bass Parts',
  bio: 'Retired music educator, Army bandsman, and multi-instrumentalist who has directed choirs, produced albums, and still finds joy in everything from classical piano to driving rock anthems.'
}, {
  name: 'Jim Rohr',
  role: 'Drums · Lead & Backup Vocals',
  bio: "Trained at LA's Musicians Institute, backed up The Outlaws' Monte Yoho, and has laid down beats for legends like Aerosmith and Cheap Trick, making him the band's unstoppable engine."
}];
function MemberCard({
  member,
  index
}: {
  member: Member;
  index: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay: index * 0.08
  }} className="relative bg-[var(--vu-cream)] text-[var(--vu-black)] border-2 border-[var(--vu-black)] shadow-[6px_6px_0_0_var(--vu-red)] p-6 flex flex-col" data-id="element-63" data-mp="2snho4ayfvd2a">
      <h3 className="flex items-center gap-2 font-display uppercase text-3xl leading-none text-[var(--vu-navy)]" data-id="element-64" data-mp="2dwsaz31f3nvs">
        {member.name}
        <span className="text-base leading-none text-[var(--vu-gold)] [text-shadow:1px_1px_0_var(--vu-black)]" aria-hidden="true" data-id="element-65" data-mp="24xncfwpuvujm">
          ★
        </span>
      </h3>
      <p className="mt-2 font-cond uppercase tracking-widest text-[11px] text-[var(--vu-red)]" data-id="element-66" data-mp="1zco4r1teeibj">
        {member.role}
      </p>
      <p className="mt-4 font-body text-sm leading-relaxed text-[var(--vu-black)]/80" data-id="element-67" data-mp="1ldopulvothsk">
        {member.bio}
      </p>
    </motion.article>;
}
export function MeetTheBand() {
  return <section id="band" className="relative w-full bg-[var(--vu-navy)] py-20 px-5 overflow-hidden grain" data-id="element-68" data-mp="2e23qu4hzhzkw">
      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-69" data-mp="2izm5mbion90t">
        <div className="text-center" data-id="element-70" data-mp="24brbcqp10wlm">
          <p className="font-cond uppercase tracking-[0.4em] text-[var(--vu-gold)] text-xs mb-2" data-id="element-71" data-mp="24apweb4w3pym">
            The Lineup
          </p>
          <h2 className="font-display uppercase text-[var(--vu-cream)] text-5xl sm:text-6xl leading-none" data-id="element-72" data-mp="2wzwvbb89ahke">
            Meet The Band
          </h2>
          <BadgeDivider data-id="element-73" data-mp="31rokpifoeh8y" />
        </div>

        <motion.figure initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mx-auto max-w-3xl mb-14 rotate-[-1deg]" data-id="element-74" data-mp="31sg8i7317aoo">
          <div className="bg-[var(--vu-cream)] p-3 pb-6 border-2 border-[var(--vu-black)] shadow-[8px_8px_0_0_var(--vu-black)]" data-id="element-75" data-mp="z2of0ek4vaxc">
            <img src={CARTOON_IMG} alt="Cartoon illustration of the four Virtually Unknown band members by the St. Pete Beach waterfront" className="w-full object-cover border border-[var(--vu-black)]/20" data-id="element-76" data-mp="v4haqj6uw231" />
            <figcaption className="mt-3 text-center font-cond uppercase tracking-widest text-[11px] text-[var(--vu-black)]/60" data-id="element-77" data-mp="gejfjjaiec4c">
              The crew, animated
            </figcaption>
          </div>
        </motion.figure>

        <div className="grid gap-8 sm:grid-cols-2" data-id="element-78" data-mp="1rr2gx5ecere6">
          {MEMBERS.map((m, i) => <MemberCard key={m.name} member={m} index={i} data-id="element-79" data-mp="1mt0vwexcwi02" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}